exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".featureflags{position:fixed;top:64px}\n", ""]);

// exports
